import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AccountsContext } from "../../../../components/context/account-context";
import { getAllVehicleExpenses, getAllVehicleFuels, getAllVehicleIncidents, getAllVehicleMeters, getAllVehicleReminders, getAllVehicleRenewals, getAllVehicleServices, getVehiclesMinimal, getAllVehicleTires, getVehicle } from "../../../../services/vehicles-service";
import { getUsersMinimal } from "../../../../services/users-service";
import { getAllExpenseCategories, getAllExpensePaymentMethods } from "../../../../services/expenses-service";
import { getJobsMinimal } from "../../../../services/jobs-service";
import { getAllIncidentTypes } from "../../../../services/incidents-service";
import { getDateRangeUTC } from "../../../../utils/set-date-range-utils";
import { getAllTirePositions, getAllTires } from "../../../../services/tires-service";
import { getAllServiceRTypes } from "../../../../services/services-service";
import { getAllVendorsMinimal } from "../../../../services/vendors-service";
import { getAllServiceConfig, getAllServiceConfigTypes } from "../../../../services/service-config-service";
import { getAllRenewalTypes } from "../../../../services/renewal-service";
import { getAllMeterTypes } from "../../../../services/meters-service";

export const useVehicleViewData = (dateRange) => {
    const { accountId, attributes } = useContext(AccountsContext);
    const { vehicleId } = useParams();

    const [vehicle, setVehicle] = useState(null);
    const [vehicleError, setVehicleError] = useState(null);
    const [loading, setLoading] = useState(true);

    const [fuelData, setFuelData] = useState([]);
    const [expenseData, setExpenseData] = useState([]);
    const [IncidentData, setIncidentData] = useState([]);
    const [meterData, setMeterData] = useState([]);
    const [tireData, setTireData] = useState([]);
    const [tirePositions, setTirePositions] = useState([]);
    const [tireUnAssign, setTireUnAssign] = useState([]);
    const [serviceData, setServiceData] = useState([]);
    const [reminderData, setReminderData] = useState([]);
    const [serviceConfigData, setServiceConfigData] = useState([]);

    const [users, setUsers] = useState([]);
    const [renewalTypes, setRenewalTypes] = useState([]);
    const [renewalData, setRenewalData] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [categories, setCategories] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [jobsOptions, setJobsOptions] = useState([]);
    const [typesOptions, setTypesOptions] = useState([]);
    const [meterTypes, setMeterTypes] = useState([]);
    const [serviceTypesOptions, setServiceTypesOptions] = useState([]);
    const [serviceConfigTypesOptions, setServiceConfigTypesOptions] = useState([]);


    const [tabStates, setTabStates] = useState({
        Fuels: { loading: false, error: null, dataFetched: false },
        Meters: { loading: false, error: null, dataFetched: false },
        Expenses: { loading: false, error: null, dataFetched: false },
        Services: { loading: false, error: null, dataFetched: false },
        Renewals: { loading: false, error: null, dataFetched: false },
        Incidents: { loading: false, error: null, dataFetched: false },
        Reminders: { loading: false, error: null, dataFetched: false },
        Tires: { loading: false, error: null, dataFetched: false },
        ServiceConfig: { loading: false, error: null, dataFetched: false },
    });

    const fetchGlobalData = async () => {
        if (!accountId) return;

        try {
            const [usersRes, vehiclesRes, vendorsRes, expenseCategoiresRes, paymentMthodsRes, jobRes, typeRes] = await Promise.all([
                getUsersMinimal(accountId),
                getVehiclesMinimal(accountId),
                getAllVendorsMinimal(accountId),
                getAllExpenseCategories(accountId),
                getAllExpensePaymentMethods(accountId),
                getJobsMinimal(accountId),
                getAllIncidentTypes(accountId),
            ]);

            if (usersRes.success) setUsers(usersRes.data.data || []);
            if (vehiclesRes.success) setVehicles(vehiclesRes.data.data || []);
            if (vendorsRes.success) setVendors(vendorsRes.data.data || []);
            if (expenseCategoiresRes.success) setCategories(expenseCategoiresRes.data.data || []);
            if (paymentMthodsRes.success) setPaymentMethods(paymentMthodsRes.data.data || []);
            if (jobRes.success) setJobsOptions(jobRes.data.data || []);
            if (typeRes.success) setTypesOptions(typeRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch global data", err);
            setVehicleError("Failed to fetch global data");
        }
    };


    const fetchRenewalTypes = async () => {
        if (!accountId) return;
        // setLoading(true);
        try {
            const [renewalRes] = await Promise.all([
                getAllRenewalTypes(accountId),
            ]);
            if (renewalRes.success) setRenewalTypes(renewalRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch renewal types data", err);
            setVehicleError('Failed to fetch renewal types data');
        } finally {
            // setLoading(false);
        }
    };

    const fetchServicesTypes = async () => {
        if (!accountId) return;

        try {
            const [typeRes] = await Promise.all([
                getAllServiceRTypes(accountId),
            ]);
            if (typeRes.success) setServiceTypesOptions(typeRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch global data", err);
            setVehicleError("Failed to fetch global data");
        }
    };
    const fetchMeterTypes = async () => {
        if (!accountId) return;

        try {
            const [typeRes] = await Promise.all([
                getAllMeterTypes(accountId),
            ]);
            if (typeRes.success) setMeterTypes(typeRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch global data", err);
            setVehicleError("Failed to fetch global data");
        }
    };

    const fetchServiceConfigTypes = async () => {
        if (!accountId) return;

        try {
            const [typeRes] = await Promise.all([
                getAllServiceConfigTypes(accountId),
            ]);
            if (typeRes.success) setServiceConfigTypesOptions(typeRes.data.data || []);
        } catch (err) {
            console.error("Failed to fetch global data", err);
            setVehicleError("Failed to fetch global data");
        }
    };


    const fetchVehicle = async () => {
        try {
            setLoading(true);
            const response = await getVehicle(accountId, vehicleId);
            if (response.success) {
                setVehicle(response.data.data);
                setVehicleError(null);
            } else {
                setVehicleError(response.data.message || "Failed to fetch vehicle details");
            }
        } catch (error) {
            setVehicleError("An error occurred while fetching vehicle details");
        } finally {
            setLoading(false);
        }
    };

    const fetchTabData = async (tabName) => {
        if (tabStates[tabName]?.loading) return;
        setTabStates((prev) => ({
            ...prev,
            [tabName]: { ...prev[tabName], loading: true, error: null },
        }));

        const { from, to } = getDateRangeUTC(dateRange);
        try {
            let response;
            switch (tabName) {
                case "Fuels":
                    response = await getAllVehicleFuels(accountId, vehicleId, from, to);
                    fetchGlobalData();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setFuelData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Fuels: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch fuel records");
                    }
                    break;
                case "Meters":
                    response = await getAllVehicleMeters(accountId, vehicleId, from, to);
                    fetchMeterTypes();
                    fetchGlobalData();

                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setMeterData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Meters: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error("Failed to fetch meter records");
                    }
                    break;
                case "Expenses":
                    response = await getAllVehicleExpenses(accountId, vehicleId, from, to);
                    fetchGlobalData();
                    console.log("Vehicle Expense : ", response)
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setExpenseData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Expenses: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch Expense records");
                    }
                    break;
                case "Services":
                    response = await getAllVehicleServices(accountId, vehicleId, from, to);
                    fetchGlobalData();
                    fetchServicesTypes();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setServiceData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Services: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch service records");
                    }
                    break;
                case "ServiceConfig":
                    response = await getAllServiceConfig(accountId);
                    fetchGlobalData();
                    fetchServiceConfigTypes();
                    fetchServicesTypes();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setServiceConfigData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            ServiceConfig: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch service records");
                    }
                    break;
                case "Renewals":
                    response = await getAllVehicleRenewals(accountId, vehicleId);
                    fetchGlobalData();
                    fetchRenewalTypes();
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setRenewalData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Renewals: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch Renewal records");
                    }
                    break;
                case "Reminders":
                    response = await getAllVehicleReminders(accountId, vehicleId, from, to);
                    // fetchGlobalData();
                    console.log("Vehicle reminders : ", response)
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setReminderData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Reminders: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch Reminders records");
                    }
                    break;
                case "Incidents":
                    response = await getAllVehicleIncidents(accountId, vehicleId, from, to);
                    fetchGlobalData();
                    console.log("Vehicle incidents : ", response)
                    if (response.success) {
                        const sortedData = response.data.data.sort(
                            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                        );
                        setIncidentData(sortedData);
                        setTabStates((prev) => ({
                            ...prev,
                            Incidents: { loading: false, error: null, dataFetched: true },
                        }));
                    } else {
                        throw new Error(response.data.message || "Failed to fetch Incidents records");
                    }
                    break;
                case "Tires":
                    setTabStates((prev) => ({
                        ...prev,
                        Tires: { ...prev.Tires, loading: true, error: null },
                    }));

                    try {
                        const [response, positionRes, tireRes] = await Promise.all([
                            getAllVehicleTires(accountId, vehicleId),
                            getAllTirePositions(accountId, vehicleId),
                            getAllTires(accountId, false)
                        ]);

                        console.log(response)

                        fetchGlobalData();

                        if (response.success && positionRes.success && tireRes.success) {
                            const sortedData = response.data.data.sort(
                                (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
                            );

                            setTireData(sortedData);
                            setTirePositions(positionRes.data.data || []);
                            setTireUnAssign(tireRes.data.data || []);

                            setTabStates((prev) => ({
                                ...prev,
                                Tires: { loading: false, error: null, dataFetched: true },
                            }));
                        } else {
                            const errors = [
                                !response.success && response.data.message,
                                !positionRes.success && positionRes.data.message,
                                !tireRes.success && tireRes.data.message
                            ].filter(Boolean);

                            throw new Error(errors.join("; ") || "Failed to fetch Tires data");
                        }
                    } catch (error) {
                        setTabStates((prev) => ({
                            ...prev,
                            Tires: {
                                loading: false,
                                error: error.message || "Failed to fetch Tires records",
                            },
                        }));
                    }
                    break;
                default:
                    break;
            }
        } catch (error) {
            setTabStates((prev) => ({
                ...prev,
                [tabName]: {
                    loading: false,
                    error: error.message || `Failed to fetch ${tabName.toLowerCase()} records`,
                },
            }));
        }
    };

    useEffect(() => {
        fetchVehicle();
    }, [accountId, vehicleId]);

    return {
        vehicle,
        setVehicle,
        vehicleError,
        loading,
        fuelData,
        setFuelData,
        expenseData,
        setExpenseData,
        IncidentData,
        setIncidentData,
        meterData,
        setMeterData,
        setTireData,
        tireData,
        tireUnAssign,
        setTireUnAssign,
        tirePositions,
        setTirePositions,
        users,
        vehicles,
        serviceData,
        setServiceData,
        reminderData,
        setReminderData,
        serviceConfigData,
        setServiceConfigData,
        renewalData,
        setRenewalData,
        renewalTypes,
        setRenewalTypes,
        meterTypes,
        setMeterTypes,
        vendors,
        categories,
        paymentMethods,
        jobsOptions,
        serviceTypesOptions,
        serviceConfigTypesOptions,
        typesOptions,
        tabStates,
        fetchTabData,
        fetchGlobalData
    };
}; 